import { h, render } from "preact";
import MainComponent from "./components/MainComponent";
import '../css/style.scss'

render(<MainComponent/>, document.getElementById('app'));